import { render, staticRenderFns } from "./DepartamentList.vue?vue&type=template&id=89bac6ba&scoped=true"
import script from "./DepartamentList.vue?vue&type=script&lang=js"
export * from "./DepartamentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bac6ba",
  null
  
)

export default component.exports